import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ServicesOverview from "./components/ServicesOverview";
import MidPageCTA from "./components/MidPageCTA";
import AIAnswerBlock from "./components/AIAnswerBlock";
import ProcessSection from "./components/ProcessSection";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceAreas from "./components/ServiceAreas";
import Testimonials from "./components/Testimonials";
import FAQSection from "./components/FAQSection";
import FinalCTA from "./components/FinalCTA";

export default function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("lp-visible");
        }),
      { threshold: 0.1 }
    );
    document.querySelectorAll(".lp-reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-brand-black min-h-screen font-sans">
      <Navbar />
      <main>
        {/* 1. Hero */}
        <HeroSection />
        {/* 2. Trust Bar */}
        <TrustBar />
        {/* 3. Services Overview */}
        <ServicesOverview />
        {/* Mid-page CTA */}
        <MidPageCTA />
        {/* 4. AI Answer Block */}
        <AIAnswerBlock />
        {/* 5. Process */}
        <ProcessSection />
        {/* 6. Why Choose Us */}
        <WhyChooseUs />
        {/* Mid-page CTA 2 */}
        <MidPageCTA />
        {/* 7. Service Areas */}
        <ServiceAreas />
        {/* 8. Testimonials */}
        <Testimonials />
        {/* 9. FAQ */}
        <FAQSection />
        {/* 10. Final CTA */}
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
